import { SelectBox } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import React from 'react'
import { Col, Row } from 'reactstrap';
import cubeApiClient from '../../../BusinessObjects/cubeApiService';
import LoggedContext from '../../../BusinessObjects/LoggedContext';
import { useAppSelector } from '../../../BusinessObjects/Redux/app/hook';
import { RootState } from '../../../BusinessObjects/Redux/app/store';
import EsaedroLookupItem from '../../../Models/EsaedroLookupItem';
import { CustomColumn } from '../../../Models/Project/CustomColumn';
import { Key } from '../../../Models/Project/CustomOtherKeysToSet';
import { PrevMateriale } from '../../../Models/Resources/PrevMateriale';
import { PrevSchedaMateriale } from '../../../Models/Resources/PrevSchedaMateriale';
import ResourceLookupValue from '../../../Models/SysConf/ResourceLookupValue';
import { DevExtremeComponentName } from '../../../Utils/DevExtremeComponentName';
import { themeCol9, themeGroup, themeSpinner } from '../../../Utils/EsaedroTheme';
import { ResourceNames } from '../../../Utils/ResourceNames';
import DelayedDataGrid from '../../Esaedro/DelayedDataGrid/DelayedDataGrid';
import DelayedDataGrid2 from '../../Esaedro/DelayedDataGrid/DelayedDataGrid2';
import { EsaedroLookupHandleChangeEvent } from '../../Esaedro/Lookup/Lookup';

type Props = {
    value:any;
    fatherObj:any;
    id:string
    isDisabled:boolean;

    otherKeysToSet: Key[] //Contiene le chiavi di un oggetto che devono essere settate oltre a quella contenente del campo id [{keyObj: '', keyValue: ''}]
    onValueChanged: (value:any) => void;

    style?:any
    className?:string;
    showClearButton?:boolean;

    renderDataGrid: boolean
}

const PrevMaterialiLookup = (props: Props) => {

    const loggedContext = React.useContext(LoggedContext)

    const [prevMateriali, setPrevMateriali] = React.useState<PrevMateriale[]>([])
    const [prevMaterialiItemToDisplay, setPrevMaterialiItemToDisplay] = React.useState<EsaedroLookupItem[]>([])
    const [loading, setLoading] = React.useState<boolean>(false)

    const tokenAPI = useAppSelector((state: RootState) => state.user.tokenAPI)

    React.useEffect(() => {
        getPrevMateriali()
    }, [])
    
    const getPrevMateriali = () => {
        setLoading(true)

        const service = new cubeApiClient()

        service.getItems(`/api/Resources/${ResourceNames.PrevMateriali}`, tokenAPI).then(
            (data:any) => {
                //Creo gli ItemToDisplay per la DelayedDataGrid
                let prevMaterialiItemToDisplay: EsaedroLookupItem[] = []

                data.forEach((p: any) => {
                    let tmpArt: any = {
                        description: p.cod_art_materiale + ' | ' + p.des_materiale,
                        value: p.cod_art_materiale
                    }

                    prevMaterialiItemToDisplay.push(tmpArt)
                })

                setLoading(false)
                setPrevMateriali(data)
                setPrevMaterialiItemToDisplay(prevMaterialiItemToDisplay)
            },
            (error:any) => {
                setLoading(false)
                setPrevMateriali([])
                setPrevMaterialiItemToDisplay([])
            }
        )
    }

    const onValueChanged = (e:any) => {

        let value = undefined

        if (e.value === null || e.value === undefined || e.value === '') {
            if (props.renderDataGrid && e.selectedRowKeys && e.selectedRowKeys.length > 0) {
                for (var key in e.currentSelectedRowKeys[0]) {
                    if (key == e.element.attributes.columnName.nodeValue) {
                        value = e.selectedRowsData[0][key];
                    }
                }
            } else {
                value = null
            }
        } else {
            if (props.renderDataGrid) {
                for (var key in e.currentSelectedRowKeys[0]) {
                    if (key == e.element.attributes.columnName.nodeValue) {
                        value = e.selectedRowsData[0][key];
                    }
                }
            } else {
                value = e.value;
            }
        }

        // Creo l'evento per il padre
        let event: EsaedroLookupHandleChangeEvent = {
            value: value,
            selectedRowsData: [],
            resourceLookupValues:   props && props.otherKeysToSet
                                    ?   props.otherKeysToSet.map((item: Key) => {
                                            let tmpRlv: ResourceLookupValue = new ResourceLookupValue()
                                            tmpRlv.LookupName = ''
                                            tmpRlv.ValueField_Name = item.keyValue
                                            tmpRlv.ValueField_Name_Alias = item.keyObj

                                            return tmpRlv
                                        })
                                    :   [],
            fieldName: props.id,
            component: props.renderDataGrid ? DevExtremeComponentName.DataGrid : DevExtremeComponentName.SelectBox
        }

        if (props.renderDataGrid && e && e.selectedRowsData){
            event.selectedRowsData = e.selectedRowsData
        } else {
            let prevMateriale = prevMateriali.find(a => a.cod_art_materiale === e.value)

            if(prevMateriale) event.selectedRowsData.push(prevMateriale)
        }

        props.onValueChanged(event)
    }

    if(loading){
        return(
            <Row className={themeGroup()}>
                <Col className={themeCol9()}>
                    <i className={themeSpinner()}></i> Caricamento...
                </Col>
            </Row>
        )
    }

    if(prevMateriali.length === 0){
        return (
            <Row className={themeGroup()}>
              <Col className={themeCol9()}>
                Nessun dato disponibile...  
              </Col>
            </Row>
        )
    }

    if(props.renderDataGrid){

        let columns:CustomColumn[] = [
            {
                dataField: 'cod_art_materiale',
                caption: 'Codice Materiale',
            },
            {
                dataField: 'des_materiale',
                caption: 'Descrizione Materiale',
            },

            // val_uca_acquis

            // dat_uca_acquis

            // val_list_acq

            // val_list_clifor

            // cod_forn_pref

            // des_forn_pref

            // flg_artbase

            // qta_ordinata

            // qta_disp
        ]

        return (
            <DelayedDataGrid2
                gridColumns={columns} 
                handleChange={onValueChanged} 
                itemsToDisplay={prevMaterialiItemToDisplay}
                fieldName={props.id}
                gridValue={props.value}
                valueColumnName={'cod_art_materiale'}
                dataGridObjects={prevMateriali}
                gridDisabled={props.isDisabled}
            />
        )
    }

    //Creo il DataSource perchè se no lagga quando l'utente vuole aprire la lookup
    const prevMaterialiDataSource = new DataSource({
        store: prevMateriali,
        paginate: true,
        pageSize: 10
    });

    return (
        <SelectBox
            disabled={loading}
            dataSource={prevMaterialiDataSource}
            showClearButton={props.showClearButton}
            valueExpr='cod_art_materiale'
            displayExpr='cod_art_materiale'
            searchEnabled={true}
            searchExpr='cod_art_materiale'
            searchTimeout={1000}
            searchMode='contains'
            id={props.id}
            onValueChanged={onValueChanged}
            value={props.value}
        />
    )
}

export default PrevMaterialiLookup